<template lang="html">
  <div class="CountDown">
    <span class="text">距结束</span>
    <span class="time">
      <i class="item">{{hh}}</i>:<i class="item">{{mm}}</i>:<i class="item">{{ss}}</i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'CountDown',

  props: ['daojishi'],

  computed: {
    hh () {
      let result = Math.floor((this.daojishi || 0) / 3600)
      if (result < 10) {
        result = '0' + result
      } else {
        result = '' + result
      }
      return result
    },
    mm () {
      let result = (Math.floor((this.daojishi || 0) / 60)) % 60
      if (result < 10) {
        result = '0' + result
      } else {
        result = '' + result
      }
      return result
    },
    ss () {
      let result = (this.daojishi || 0) % 60
      if (result < 10) {
        result = '0' + result
      } else {
        result = '' + result
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.CountDown{
  background-color: #FDEAE2;
  border-radius: 5px;
  width: 147px;
  text-align: right;
  padding: 0px 12px 0px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  align-items:center;
  -webkit-align-items: center;
  box-sizing: border-box;
  color: #ED442F;

  span{
    font-family: 'PingFang-SC-Regular';
    font-size: 12px;
    line-height: 20.5px;
  }
  .item{
    display: inline-block;
    width: 24px;
    text-align: center;
    font-style: normal;

  }
  .text{
    // float: left;
    // background-color: green;

  }
  .time{
    // background-color: blue;
    // float: right;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/CountDown/index.vue